import type { Partner } from "@expert/shared-types";

import { getAppConfigSingleton } from "@expert/app-config";

export function isDeviceActivationIntent(intent?: string) {
    return intent?.toLowerCase() === "device activation";
}

export function isDeviceActivationQueue({ partner, queueName }: { partner: Partner; queueName?: string }) {
    if (!queueName) return false;

    const partnerConfig = getAppConfigSingleton().getPartnersConfig;
    const partnerConfigInfo = partnerConfig(partner);
    return queueName && partnerConfigInfo.activationSupportQueues?.includes(queueName);
}

export function isDeviceActivationSupportNumber({
    partner,
    supportNumberCalled,
}: {
    partner: Partner;
    supportNumberCalled?: string;
}) {
    if (!supportNumberCalled) return false;

    const partnerConfig = getAppConfigSingleton().getPartnersConfig;
    const partnerConfigInfo = partnerConfig(partner);
    return supportNumberCalled && partnerConfigInfo.activationSupportNumbers?.includes(supportNumberCalled);
}
